import script from "./BusinessHallBJlMonthlyMbdc.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessHallBJlMonthlyMbdc.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessHallBJlMonthlyMbdc.vue?vue&type=style&index=0&id=7c8de086&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c8de086"]])

export default __exports__